import React from 'react'
import { Card, CardContent, CardMedia, Typography, CardActionArea} from "@mui/material";
import moment from "moment";
import fecha_1 from '../../../statics/img/fechas/fecha_m01_b.png'
import fecha_2 from '../../../statics/img/fechas/fecha_m02_b.png'

const img = [fecha_1, fecha_2]

interface Props {
    index: number
    fecha: string
    onClick?: () => void
}

const CardFechaM:React.FC<Props> = ({index, fecha, onClick}) =>{
    return <>
        <Card>
            <CardActionArea onClick={onClick}>
                <CardMedia
                    sx={{height: 140}}
                    image={img[index % img.length]} // Asegurar que el índice no desborde
                    title={"hipodromo-fecha"}
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div" align="center">
                        {moment(fecha).format('DD-MM-YYYY')}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    </>
}

export default CardFechaM